<div id="wrapper">
	<div>
		<app-menu [tabActive]="this.tabActive"></app-menu>
	</div>
	<div class="allcont logsize">
		<div class="basicrow ">
			<div class="container">
				<div class="basicr-line-i">
					<div class="fulltitle  f-btitle autodef">
						<span class="icon-dash-01"></span> Factura Electrónica
					</div>
					<div class="pull-right">
						<label class="label-r sidenmbr vcenter w-auto">
							<span class="tabcell NCuenta">
								N&uacute;mero de Cuenta
							</span>
						</label>
						<div class="autorow subsc  mob-wid pull-right">
							<div>
								<select (change)="changeBan()" [(ngModel)]="this.selectBan" class="sel-f" style="background-image:url(/assets/images/selectabarrw.png)">
              						<option disabled value="">N&uacute;mero de Cuenta</option>
              						<option *ngFor="let account of this.banlist" [ngValue]="account.account">{{account.account}}</option>
            					</select>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="basicrow mbott-i">
			<div class="container">
				<app-paperless-module [paperless]="this.paperless"></app-paperless-module>
			</div>
		</div>
	</div>
	<app-footer></app-footer>
</div>